import axios from 'axios';

import interceptors from './interceptors.js'; // eslint-disable-line no-unused-vars
// 1. HTTP Request & Response와 관련된 기본 설정
const config = {
  baseUrl: process.env.VUE_APP_SURVEY_API_BASE,
};

async function checkSurveyPosb(frlProgressCd) {
  return await axios.get(`${config.baseUrl}/survey/posb`, {
    params: {
      frlProgressCd,
    },
    withCredentials: true,
  });
}

async function fetchSurveyQuestionStart(frlProgressCd) {
  try {
    return await axios.get(`${config.baseUrl}/survey/ques/start`, {
      params: {
        frlProgressCd,
      },
      withCredentials: true,
    });
  } catch (error) {
    console.log(error);
  }
}

async function fetchSurveyQuestionNext(
  beforeSurveyQuesId,
  acmltSurveyAnsItmId
) {
  try {
    return await axios.get(`${config.baseUrl}/survey/ques/next`, {
      params: {
        beforeSurveyQuesId,
        acmltSurveyAnsItmId: acmltSurveyAnsItmId.join(','),
      },
      withCredentials: true,
    });
  } catch (error) {
    console.log(error);
  }
}

export { checkSurveyPosb, fetchSurveyQuestionStart, fetchSurveyQuestionNext };
